import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";

export default {
    title: "Components/Discontinuation Icon & Tooltip",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    component: "ux-iws-discontinuation-tooltip",
    args: {
        extendedSupport: false,
        head: "",
        link: "#",
        linkText: "",
        status: "soc",
        text: "",
        tooltipIdentifier: "",
        type: "",
    },
    argTypes: {
        extendedSupport: { control: "boolean" },
        head: { control: "text" },
        link: { control: "text" },
        linkText: { control: "text" },
        status: { control: { type: "radio" }, options: ["soc", "sod"] },
        text: { control: "text" },
        tooltipIdentifier: { control: "text" },
        type: { control: { type: "radio" }, options: ["machine", "equipment"] },
    },
};

const Template = ({
    extendedSupport,
    head,
    link,
    linkText,
    status,
    text,
    tooltipIdentifier,
    type,
}) =>
    html`
        <ux-iws-discontinuation-icon
            tooltip-identifier="${tooltipIdentifier}"
            type="${type}"
            status="${status}"
            extended-support="${extendedSupport}"
        ></ux-iws-discontinuation-icon>
        <ux-iws-discontinuation-tooltip
            extended-support="${extendedSupport}"
            head="${head}"
            link="${link}"
            link-text="${linkText}"
            status="${status}"
            text="${text}"
            tooltip-identifier="${tooltipIdentifier}"
            type="${type}"
        ></ux-iws-discontinuation-tooltip>
    `;

export const Default = Template.bind({});
Default.args = {
    head: "Das Produkt wird zum 31.12.2021 abgekündigt.",
    linkText: "Mehr erfahren",
    text:
        "Leider kann deshalb nur ein eingeschränkter Support zur Verfügung gestellt werden. Sollten Sie Fragen zur Abkündigung haben, wenden Sie sichgerne an Ihren Service-Ansprechpartner bei TRUMPF.",
    tooltipIdentifier: "TWDEDM0",
    type: "machine",
};
Default.argTypes = {
    status: {
        contol: { type: "radio" },
        options: ["soc", "sod"],
    },
    type: {
        control: { type: "radio" },
        options: ["machine", "equipment"],
    },
};
